import { createContext } from 'react';
import { io, Socket } from 'socket.io-client';
import { appConfig } from 'app/config/appConfig';

export const socket = io(appConfig.hostApi || 'http://localhost:5001');
export const WebsocketContext = createContext<Socket>(socket);
export const WebsocketProvider = WebsocketContext.Provider;
